import { useEffect, useRef } from "react";
import { Navigate, Routes, Route, useNavigate } from "react-router";
import Welcome from "./pages/Welcome";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import SetPassword from "./pages/SetPassword";
import Register from "./pages/Register";
import PasswordSaved from "./pages/PasswordSaved";
import Varification from "./pages/Varification";
import VarificationCode from "./pages/VarificationCode";
import Confirmation from "./pages/Confirmation";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Home from "./pages/Home";
import MyAccount from "./pages/MyAccount";
import Auth from "./ProtectedRoutes/Auth";
import MyAppointmentsNotSelected from "./pages/patient/my-appointments-not-selected";
import MyAppointment from "./pages/patient/my-appointments-upcoming";
import MyAppointment2 from "./pages/patient/my-appointments-rescheduled";
import MyAppointment3 from "./pages/patient/my-appointments-canceled-by-doctor";
import MyAppointment4 from "./pages/patient/my-appointments-patient-not-attended";
import MyAppointments5 from "./pages/patient/my-appointments-doctor-absent";
import MyAppointment6 from "./pages/patient/my-appointments-completed";
import DoctorLanding from "./pages/doctor/DoctorLanding";
import Approval from "./pages/doctor/Approval";
import DoctorLogin from "./pages/doctor/DoctorLogin";
import ConfirmationAdmin from "./pages/doctor/ConfirmationAdmin";
import LoadingPage from "./components/LoadingPage";
import SetAvailability from "./pages/doctor/set-availability";
import "react-loading-skeleton/dist/skeleton.css";
import DoctorCreactProfile from "./pages/doctor/doctor-creact-profile";
import Nurse from "./pages/nurse/nurses";
import DoctorCreateProfile2 from "./pages/doctor/doctor-create-profile2";
import IncompleteDocProAuth from "./ProtectedRoutes/IncompleteDocProAuth";
import BookAppointment from "./pages/patient/bookAppointment";
import BookingConfirm from "./pages/patient/bookingConfirm";
import DoctorMyAccount from "./pages/doctor/doctor-my-account";
import VerifyAccount from "./pages/VerifyAccount";
import VerifyDoctorAccount from "./pages/doctor/VerifyDoctorAccount";
import SearchListing from "./pages/SearchListing";
import DoctorDetails from "./pages/doctor/DoctorDetails";
import DoctorDetailsFromPatient from "./pages/DoctorDetailsFromPatient";
import ConsultationObservations from "./pages/doctor/consultation-observations";
import WorkspaceConfig from "./pages/doctor/WorkspaceConfig";
import NotLogInAuth from "./ProtectedRoutes/NotLogInAuth";
import DoctorPatientMessage from "./pages/doctor/doctor-patient-message";
import PrescriptionManagement from "./pages/doctor/PrescriptionManagement";
import AdminPrescriptionManagement from "./pages/doctor/AdminPrescriptionManagement";
import Error from "./pages/404";
import AdminEditPrescriptionTemplate from "./pages/doctor/AdminEditPrescriptionTemplate";
import AddPrescriptionByDoctor from "./pages/doctor/AddPrescriptionByDoctor";
import EditPrescriptionByDoctor from "./pages/doctor/EditPrescriptionByDoctor";
import Cookies from "js-cookie";
import { useLocation } from "react-router";
import { useUserContext } from "./context/UserContext";
import { onLogout } from "./utils/commonData";
import NurseLogin from "./pages/nurse/NurseLogin";
import NurseAppointments from "./pages/nurse/NurseAppointments";
import NurseMyAccount from "./pages/nurse/nurse-my-account";
import BookAppointmentByNurse from "./pages/nurse/BookAppointmentByNurse";
import BookAppointmentByDoctor from "./pages/doctor/BookAppointmentByDoctor";
import PatientDictonary from "./pages/doctor/PatientDictonary";
import NewPatientDictonary from "./pages/doctor/new-patient-dictionary";
import RegisterCreatePassword from "./pages/RegisterCreatePassword";
import RegisterNewUser from "./pages/RegisterNewUser";
import FavouriteDoctor from "./pages/patient/FavouriteDoctor";
import NotificationList from "./pages/patient/NotificationList";
import TermsOfUseOfDoctolibServices from "./pages/TermsOfUseOfDoctolibServices";
import ContactUs from "./pages/ContactUs";
import DoctorConfiguration from "./pages/doctor/DoctorConfiguration";
import PatientMedicalReport from "./pages/doctor/PatientMedicalReport";
import HelpCenter from "./pages/doctor/HelpCenter";
import NotificationsHistory from "./pages/doctor/NotificationsHistory";
import Subscription from "./pages/doctor/Subscription";
import Collaboration from "./pages/doctor/Collaboration";

import AppDownloadValidation from "./pages/AppDownloadValidation";
import DocumentationScan from "./pages/DocumentationScan";
import { QueryShowcase } from "./components/query";
import RetryableLazyRoute from "./features/error/RetryableLazyRoute";

const loadDashboard = () => import("./pages/doctor/dashboard");
const loadDoctorMessage = () => import("./pages/doctor/doctor-message");
const loadAppointments = () => import("./pages/doctor/appointments");
const loadConsultationPlugin = () => import("./pages/doctor/ConsultationPluginPage");
const loadPatientFiles = () => import("./pages/doctor/PatientFilesPage");
const loadPublicDoctorProfile = () => import("./features/public-doctor-profile/PublicDoctorProfilePage");

function App() {
  const { setCookiesValue, setUserData, userData } = useUserContext();
  const location = useLocation();
  const navigate = useNavigate();
  const initialViewportContent = useRef(null); // Store initial viewport content

  // Store initial viewport content on mount
  useEffect(() => {
    const viewportMeta = document.querySelector('meta[name="viewport"]');
    if (viewportMeta) {
      initialViewportContent.current = viewportMeta.getAttribute('content');
    }
  }, []);

  const handleLogout = () => {
    onLogout("notshow");
    setUserData(null);
    navigate("/");
    setCookiesValue(null);
  };

  useEffect(() => {
    let val = Cookies.get("doctolikAuthToken");
    if (userData && !val) {
      handleLogout();
    }
  }, [location.pathname]);

  useEffect(() => {
    const user = userData?.users || {};
    const uid = user?.id || user?.user_id || user?.email ? String(user?.id || user?.user_id || user?.email) : "guest";
    const isMsgPage = location.pathname.toLowerCase().includes("message");

    const updateTawk = () => {
      if (window.Tawk_API && typeof window.Tawk_API.setAttributes === "function") {
        const lastUid = window.sessionStorage.getItem('tawk_last_uid');
        if (lastUid && lastUid !== uid) {
          if (typeof window.Tawk_API.logout === "function") window.Tawk_API.logout();
        }
        window.sessionStorage.setItem('tawk_last_uid', uid);

        if (typeof window.Tawk_API.setAttributes === 'function') {
          window.Tawk_API.setAttributes({
            name: `${user.first_name || ""} ${user.last_name || ""}`.trim() || user.name || "User",
            email: user.email || "",
            userId: uid !== "guest" ? uid : undefined
          }, () => {});
        }

        if (typeof window.Tawk_API.disableTriggers === 'function') window.Tawk_API.disableTriggers();
        if (typeof window.Tawk_API.hideWidget === 'function') window.Tawk_API.hideWidget();

        if (isMsgPage) {
          if (typeof window.Tawk_API.enableTriggers === 'function') window.Tawk_API.enableTriggers();
          if (typeof window.Tawk_API.showWidget === 'function') window.Tawk_API.showWidget();
        } else {
          if (typeof window.Tawk_API.hideWidget === "function") {
            window.Tawk_API.hideWidget();
            document.documentElement.classList.remove('tawk-mobile-body-fixed');
            document.body.classList.remove('tawk-mobile-body-fixed');
            document.documentElement.style.overflow = '';
            document.body.style.overflow = '';
            document.documentElement.style.position = '';
            document.body.style.position = '';
          }
        }
      } else {
        setTimeout(updateTawk, 1000);
      }
    };

    // Function to clean up Tawk.to related styles
    const cleanTawkStyles = () => {
      setTimeout(() => { // Delay cleanup to allow Tawk.to's own cleanup to run
        document.documentElement.classList.remove('tawk-mobile-body-fixed');
        document.body.classList.remove('tawk-mobile-body-fixed');
        document.documentElement.style.overflow = 'unset'; // Réinitialisation explicite
        document.body.style.overflow = 'unset';           // Réinitialisation explicite
        document.documentElement.style.position = 'unset'; // Réinitialisation explicite
        document.body.style.position = 'unset';           // Réinitialisation explicite
        document.documentElement.style.transform = 'none'; // Réinitialisation explicite
        document.body.style.transform = 'none';           // Réinitialisation explicite
        document.documentElement.style.zoom = '1';        // Réinitialisation explicite
        document.body.style.zoom = '1';                 // Réinitialisation explicite
        document.documentElement.style.boxSizing = 'border-box'; // Réinitialisation explicite
        document.body.style.boxSizing = 'border-box';           // Réinitialisation explicite
        document.documentElement.style.minWidth = '';
        document.body.style.minWidth = '';
        document.documentElement.style.maxWidth = '';
        document.body.style.maxWidth = '';
        document.documentElement.style.width = '';
        document.body.style.width = '';
        document.documentElement.style.height = '';
        document.documentElement.style.height = '';
        document.documentElement.style.fontSize = '';
        document.body.style.fontSize = '';
        document.documentElement.style.margin = '';
        document.body.style.margin = '';
        document.documentElement.style.padding = '';
        document.body.style.padding = '';
        document.documentElement.style.transformOrigin = '';
        document.body.style.transformOrigin = '';           // Nouvelle réinitialisation

        // Réinitialisation des styles pour l'élément #root
        const rootElement = document.getElementById('root');
        if (rootElement) {
          rootElement.style.width = '';
          rootElement.style.height = '';
          rootElement.style.minWidth = '';
          rootElement.style.maxWidth = '';
          rootElement.style.transform = '';
          rootElement.style.position = '';
          rootElement.style.left = '';
          rootElement.style.top = '';
          rootElement.style.margin = '';
          rootElement.style.padding = '';
          console.log("#root styles cleaned up.");
        }

        // Réinitialiser le viewport meta tag
        const viewportMetas = document.querySelectorAll('meta[name="viewport"]');
        viewportMetas.forEach(meta => meta.remove()); // Supprimer toutes les balises viewport

        const newViewportMeta = document.createElement('meta');
        newViewportMeta.name = 'viewport';
        newViewportMeta.content = initialViewportContent.current || 'width=device-width, initial-scale=1.0';
        document.head.appendChild(newViewportMeta);
        console.log("Viewport meta tag removed and recreated.");

        // Force a reflow of the document to ensure layout is recalculated
        document.body.offsetHeight;
        console.log("Document reflow forced.");

        console.log("Tawk.to styles cleaned up.");
      }, 200); // 200ms delay
    };

    // Add a listener for when the chat widget is hidden (e.g., by user closing it)
    if (window.Tawk_API) {
      window.Tawk_API.onChatHidden = cleanTawkStyles;
      window.Tawk_API.onChatMinimized = cleanTawkStyles; // Also clean up when minimized
    }

    updateTawk();
  }, [location.pathname, userData]);

  useEffect(() => {
    const handleTitleChange = () => {
      if (document.title.includes("new message") || document.title.includes("nouveau message") || /^\(\d+\)/.test(document.title)) {
        document.title = "Doctolik";
      }
    };

    // Initial check
    handleTitleChange();

    // Observe title changes
    const target = document.querySelector('title');
    if (target) {
      const observer = new MutationObserver(handleTitleChange);
      observer.observe(target, { subtree: true, characterData: true, childList: true });
      return () => observer.disconnect();
    }
  }, []);

  return (
    <>
      <Routes>
        <Route path="/" exact element={<Home />} />
        <Route path="/verification" element={<Varification />} />
        <Route path="/verificationcode" element={<VarificationCode />} />
        <Route path="/confirmation" element={<Confirmation />} />
        <Route path="/confirm-account/:token" element={<VerifyAccount />} />
        <Route path="/doctor/confirm-account/:token" element={<VerifyDoctorAccount />} />
        <Route path="/search-listing" element={<SearchListing />} />
        <Route
          path="/doctors/:slug"
          element={
            <RetryableLazyRoute
              loader={loadPublicDoctorProfile}
              loadingFallback={<LoadingPage />}
              routeKey="public-doctor-profile"
            />
          }
        />
        <Route path="/search/doctor-details/:slug" element={<DoctorDetailsFromPatient />} />
        <Route path="/admin/add-prescription-template/:token" element={<AdminPrescriptionManagement />} />
        <Route path="/admin/edit-prescription-template/:token/:templateId" element={<AdminEditPrescriptionTemplate />} />
        <Route path="/terms-and-conditions" element={<TermsOfUseOfDoctolibServices />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/documentation_scan/privacy" element={<DocumentationScan />} />
        <Route
          path="/payment/success"
          element={<Navigate to="/doctor/subscription?status=success" replace />}
        />
        <Route
          path="/payment/failed"
          element={<Navigate to="/doctor/subscription?status=failed" replace />}
        />

        <Route element={<NotLogInAuth />}>
          <Route path="/patient/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/doctor/login" element={<DoctorLogin />} />
          <Route path="/setpassword/:id" element={<SetPassword />} />
          <Route path="/savedpassword" element={<PasswordSaved />} />
          <Route path="/register" element={<Register />} />
          <Route path="/register/set-password" element={<RegisterCreatePassword />} />
          <Route path="/register/new" element={<RegisterNewUser />} />
          <Route path="/welcome" exact element={<Welcome />} />
        </Route>

        {/* Role for Patient */}
        <Route element={<Auth allowedRoles={["Patient"]} />}>
          <Route path="/my-profile" element={<MyAccount />} />
          {/* patientnanai */}
          <Route path="/my-appointments-not-selected" element={<MyAppointmentsNotSelected />} />
          <Route path="/my-appointments" element={<MyAppointment />} />
          <Route path="/my-appointments-rescheduled" element={<MyAppointment2 />} />
          <Route path="/my-appointments-canceled-by-doctor" element={<MyAppointment3 />} />
          <Route path="/my-appointments-patient-not-attended" element={<MyAppointment4 />} />
          <Route path="/my-appointments-doctor-absent" element={<MyAppointments5 />} />
          <Route path="/my-appointments-completed" element={<MyAppointment6 />} />
          <Route path="/appointment-booking" element={<BookAppointment />} />
          <Route path="/appointment-booking/confirm" element={<BookingConfirm />} />
          <Route path="/favourite-doctor" element={<FavouriteDoctor />} />
          <Route path="/notifications" element={<NotificationList />} />
          {/* patientnanai */}
        </Route>

        {/* Doctor */}
        <Route path="/doctor/home" element={<DoctorLanding />} />
        <Route path="/doctor/approval" element={<Approval />} />

        <Route element={<Auth allowedRoles={["Doctor"]} />}>
          <Route path="/doctor/confirmation" element={<ConfirmationAdmin />} />
          <Route path="/doctor/incomplete-profile" element={<DoctorCreateProfile2 />} />
          <Route path="/doctor/profile" element={<DoctorCreactProfile />} />
          <Route path="/doctor/account" element={<DoctorMyAccount />} />
          <Route element={<IncompleteDocProAuth allowedRoles={["Doctor"]} />}>
            <Route
              path="/doctor/dashboard"
              element={
                <RetryableLazyRoute
                  loader={loadDashboard}
                  loadingFallback={<LoadingPage />}
                  routeKey="doctor-dashboard"
                />
              }
            />
            <Route path="/doctor/availability" element={<SetAvailability />} />
            <Route
              path="/doctor/appointments"
              element={
                <RetryableLazyRoute
                  loader={loadAppointments}
                  loadingFallback={<LoadingPage />}
                  routeKey="doctor-appointments"
                />
              }
            />
            <Route path="/doctor/nurses" element={<Nurse />} />
            <Route path="/doctor/profile/view" element={<DoctorDetails />} />
            <Route path="/doctor/appointment-details/:appId" element={<ConsultationObservations />} />
            <Route
              path="/doctor/appointment-details/:appId/plugin/:pluginId"
              element={
                <RetryableLazyRoute
                  loader={loadConsultationPlugin}
                  loadingFallback={<LoadingPage />}
                  routeKey="doctor-consultation-plugin"
                />
              }
            />
            <Route
              path="/doctor/appointment-details/:appId/files"
              element={
                <RetryableLazyRoute
                  loader={loadPatientFiles}
                  loadingFallback={<LoadingPage />}
                  routeKey="doctor-patient-files"
                />
              }
            />
            <Route path="/doctor/workspace-config" element={<WorkspaceConfig />} />
            <Route
              path="/doctor/messages"
              element={
                <RetryableLazyRoute
                  loader={loadDoctorMessage}
                  loadingFallback={<LoadingPage />}
                  routeKey="doctor-messages"
                />
              }
            />
            <Route path="/doctor/patient-messages/:patientId" element={<DoctorPatientMessage />} />
            <Route path="/doctor/prescription-management" element={<PrescriptionManagement />} />
            <Route path="/doctor/add-prescription-template" element={<AddPrescriptionByDoctor />} />
            <Route path="/doctor/edit-prescription-template/:templateId" element={<EditPrescriptionByDoctor />} />
            <Route path="/doctor/appointment-booking" element={<BookAppointmentByDoctor />} />
            <Route path="/doctor/patient-dictionary/:patientId" element={<PatientDictonary />} />
            <Route path="/doctor/new-patient-dictionary/:patientId" element={<NewPatientDictonary />} />
            <Route path="/doctor/patient-medical-report/:patientId" element={<PatientMedicalReport />} />
            <Route path="/doctor/configuration" element={<DoctorConfiguration />} />
            <Route path="/doctor/help-center" element={<HelpCenter />} />
            <Route path="/doctor/notifications-history" element={<NotificationsHistory />} />
            <Route path="/doctor/collaboration" element={<Collaboration />} />
            <Route path="/doctor/subscription" element={<Subscription />} />
          </Route>
        </Route>

        {/* Nurse */}
        <Route path="/nurse/login" element={<NurseLogin />} />

        <Route element={<Auth allowedRoles={["Nurse"]} />}>
          <Route path="/nurse/appointments" element={<NurseAppointments />} />
          <Route path="/nurse/account" element={<NurseMyAccount />} />
          <Route path="/nurse/appointment-booking" element={<BookAppointmentByNurse />} />
          <Route path="/nurse/patient-dictionary/:patientId" element={<PatientDictonary />} />
          <Route path="/nurse/help-center" element={<HelpCenter />} />
        </Route>

        <Route path="/scan-app-download" element={<AppDownloadValidation />} />
        <Route path="/query-showcase" element={<QueryShowcase />} />

        <Route path="*" element={<Error />} />
      </Routes>

      <ToastContainer />
    </>
  );
}

export default App;
